import React from "react";
import cx from "classnames";

import * as styles from "./videoEmbed.module.scss";
import generateRandomId from "../../helpers/generateRandomId";

// TODO PRop Types
const videoWidth = {
  fullWidth: "256:81",
  middleWidth: "1:1",
  largeWidth: "16:9",
};
function VideoEmbed(props) {
  const { aspect, titleSubtitle, url, className } = props;

  const videoClass = cx({
    [styles.fullWidth]: aspect === videoWidth.fullWidth,
    [styles.largeWidth]: aspect === videoWidth.largeWidth,
    [styles.middleWidth]: aspect === videoWidth.middleWidth,
  });
  return (
    <div className={cx(styles.videoEmbedWrap, className)}>
      {titleSubtitle && (
        <h3>{titleSubtitle.titleText}</h3>
      )}
      <iframe
        allowFullScreen
        className={videoClass}
        src={url}
        title={titleSubtitle?.titleText || generateRandomId()}
        height="315"
      />
    </div>
  );
}

export default VideoEmbed;
